var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M41.4,6.04h-6.7v-.87c0-1.1-.9-2-2-2s-2,.9-2,2v.87h-13.39v-.87c0-1.1-.9-2-2-2s-2,.9-2,2v.87H6.6c-1.1,0-2,.9-2,2V42.83c0,1.1,.9,2,2,2H41.4c1.1,0,2-.9,2-2V8.04c0-1.1-.9-2-2-2ZM8.6,10.04h4.7v.35c0,1.1,.9,2,2,2s2-.9,2-2v-.35h13.39v.35c0,1.1,.9,2,2,2s2-.9,2-2v-.35h4.7v4.3H8.6v-4.3Zm25.51,14.71l-11.85,11.85-8.37-8.37c-.78-.78-.78-2.05,0-2.83s2.05-.78,2.83,0l5.54,5.54,9.02-9.02c.78-.78,2.05-.78,2.83,0s.78,2.05,0,2.83Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4,14.45v-4.44h-4.7v.35c0,1.1-.9,2-2,2s-2-.9-2-2v-.35h-13.39v.35c0,1.1-.9,2-2,2s-2-.9-2-2v-.35h-4.7v4.44h30.79Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61,18.45v22.35h30.79V18.45H8.61Zm25.51,6.27l-11.85,11.85-8.37-8.37c-.78-.78-.78-2.05,0-2.83s2.05-.78,2.83,0l5.54,5.54,9.02-9.02c.78-.78,2.05-.78,2.83,0s.78,2.05,0,2.83Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.4,6.01h-6.7v-.87c0-1.1-.9-2-2-2s-2,.9-2,2v.87h-13.39v-.87c0-1.1-.9-2-2-2s-2,.9-2,2v.87H6.61c-1.1,0-2,.9-2,2V42.8c0,1.1,.9,2,2,2H41.4c1.1,0,2-.9,2-2V8.01c0-1.1-.9-2-2-2ZM13.31,10.01v.35c0,1.1,.9,2,2,2s2-.9,2-2v-.35h13.39v.35c0,1.1,.9,2,2,2s2-.9,2-2v-.35h4.7v4.44H8.61v-4.44h4.7Zm-4.7,30.79V18.45h30.79v22.35H8.61Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.29,21.89l-9.02,9.02-5.54-5.54c-.78-.78-2.05-.78-2.83,0s-.78,2.05,0,2.83l8.37,8.37,11.85-11.85c.78-.78,.78-2.05,0-2.83s-2.05-.78-2.83,0Z",
    fill: outlineColor
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: -0.03,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEvent);
export default __webpack_public_path__ + "static/media/ico-event.3c7f208a85e22567ba67c39702b5ae55.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;